import React from 'react';
import { Box } from '@mui/material';
import Navbar from './Navbar';
import Subheader from './Subheader';

const Header = () => {
  return (
    <Box borderBottom={1} borderColor="grey.300">
     <Navbar/>
     <Subheader/>
    </Box>
  );
};

export default Header;
